export default __webpack_public_path__ + "static/media/show.73f38d6f.svg";